// extracted by mini-css-extract-plugin
export var childrenContainer = "_87-0";